import { Bar, Doughnut } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js"

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
)

export default function AdminDashboardChart({ batches }) {
  const trainerBatchCount = {}
  batches.forEach((batch) => {
    if (batch.trainerId && batch.trainerId.length > 0) {
      batch.trainerId.forEach((trainer) => {
        if (!trainerBatchCount[trainer.name]) {
          trainerBatchCount[trainer.name] = 0
        }
        trainerBatchCount[trainer.name] += 1
      })
    }
  })

  const barDataTrainer = {
    labels: Object.keys(trainerBatchCount),
    datasets: [
      {
        label: "Batches per Trainer",
        data: Object.values(trainerBatchCount),
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        borderColor: "rgba(54, 162, 235, 1)",
        borderWidth: 1,
      },
    ],
  }

  const barOptionsTrainer = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "Batches per Trainer" },
    },
  }

  const batchNames = batches.map((b) => {
    const trainerNames =
      b.trainerId && b.trainerId.length > 0
        ? b.trainerId.map((t) => t.name).join(", ")
        : "No Trainer"
    return `${b.name || "Unnamed"} (${trainerNames})`
  })

  const studentCounts = batches.map(
    (b) => (b.studentsId && b.studentsId.length) || 0
  )

  //  Dynamic color generator so each batch gets a unique color
  const generateColors = (count, opacity = 0.6) => {
    const colors = []
    for (let i = 0; i < count; i++) {
      const hue = (i * 137.508) % 360 // golden angle for evenly spaced colors
      colors.push(`hsla(${hue}, 70%, 55%, ${opacity})`)
    }
    return colors
  }

  const backgroundColors = generateColors(batchNames.length, 0.6)
  const borderColors = generateColors(batchNames.length, 1)

  const doughnutDataBatchStudents = {
    labels: batchNames,
    datasets: [
      {
        label: "Students per Batch",
        data: studentCounts,
        backgroundColor: backgroundColors,
        borderColor: borderColors,
        borderWidth: 1,
      },
    ],
  }

  const doughnutOptionsBatchStudents = {
    responsive: true,
    plugins: {
      legend: { position: "right" },
      title: { display: true, text: "Students per Batch" },
    },
  }

  return (
    <>
      <div className="row mt-4">
        <div className="col-md-12">
          <div className="card card-round">
            <div className="card-header">
              <h4 className="card-title">Batches per Trainer</h4>
            </div>
            <div className="card-body">
              {Object.keys(trainerBatchCount).length > 0 ? (
                <Bar data={barDataTrainer} options={barOptionsTrainer} />
              ) : (
                <p>No batch data available</p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-md-12">
          <div className="card card-round">
            <div className="card-header">
              <h4 className="card-title">Students per Batch</h4>
            </div>
            <div className="card-body">
              {batchNames.length > 0 ? (
                <Doughnut
                  data={doughnutDataBatchStudents}
                  options={doughnutOptionsBatchStudents}
                />
              ) : (
                <p>No batch data available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
